module.exports = __webpack_public_path__ + "img/about.eae17b95.png";